<template>
  <h5></h5>
  <VehicleTripsSummary :totalTrips="totalTrips" :totalDistance="totalDistance" :totalEmissions="totalEmissions" :totalFuelBurned="totalFuelBurned" :totalFuelCost="totalFuelCost" />
  <div class="row d-flex flex-row-reverse" style="margin-bottom: 10px">
    <div class="col-md-1 float-right">
      <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
        <input
          type="radio"
          class="btn-check"
          name="btnradio"
          id="btnradio1"
          autocomplete="off"
          v-on:change="setDisplayMode('grid')"
        />
        <label class="btn btn-outline-primary" for="btnradio1"><i class="bi bi-grid"></i></label>

        <input
          type="radio"
          class="btn-check"
          name="btnradio"
          id="btnradio2"
          autocomplete="off"
          checked
          v-on:change="setDisplayMode('table')"
        />
        <label class="btn btn-outline-primary" for="btnradio2"><i class="bi bi-table"></i></label>
      </div>
    </div>
  </div>
  <div class="row" v-if="displayMode === 'grid'">
    <VehicleTripsGrid :tripsWithManualAndPredictedTags="tripsWithManualAndPredictedTags" />
  </div>
  <div class="table-responsive" v-if="displayMode === 'table'">
    <VehicleTripsTabular :tripsWithManualAndPredictedTags="tripsWithManualAndPredictedTags" />
  </div>
</template>

<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';
import VehicleTripsTabular from '@/components/VehicleTripsTabular.vue';
import VehicleTripsGrid from '@/components/VehicleTripsGrid.vue';
import VehicleTripsSummary from '@/components/VehicleTripsSummary.vue';

export default {
  name: 'VehicleView',
  setup() {},
  components: {
    VehicleTripsTabular,
    VehicleTripsGrid,
    VehicleTripsSummary
  },
  data() {
    return {
      displayMode: 'table',
      totalTrips: 0,
      totalDistance: 0,
      totalEmissions: 0,
      totalFuelBurned: 0,
      totalFuelCost: 0,
      vehicle: {},
      tripsWithManualAndPredictedTags: []
    };
  },
  async created() {
    const vehicleId = this.$route.params.id;
    await this.loadVehicle(vehicleId);
    await this.loadTripsWithTags(vehicleId);
    this.totalTrips = this.tripsWithManualAndPredictedTags.length;
    this.totalDistance = this.tripsWithManualAndPredictedTags
      .reduce((sum, trip) => sum + parseFloat(trip.distance) || 0, 0)
      .toFixed(2);
    this.totalEmissions = this.tripsWithManualAndPredictedTags
      .reduce((sum, trip) => sum + parseFloat(trip.co2) || 0, 0)
      .toFixed(2);
    this.totalFuelBurned = this.tripsWithManualAndPredictedTags
      .reduce((sum, trip) => sum + parseFloat(trip.litres) || 0, 0)
      .toFixed(2);
    this.totalFuelCost = this.tripsWithManualAndPredictedTags
      .reduce((sum, trip) => sum + parseFloat(trip.fuelCost) || 0, 0)
      .toFixed(2);
  },
  methods: {
    setDisplayMode(mode) {
      this.displayMode = mode;
    },
    loadVehicle: async function(vehicleId) {
      const result = await apiClient(`vehicles/${vehicleId}`, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        this.vehicle = result.data;
      }
    },
    groupTagsByType: function(tags) {
      return tags.reduce((r, a) => {
        r[a.tagtype] = [...(r[a.tagtype] || []), a];
        return r;
      }, {});
    },
    loadTripsWithTags: async function(vehicleId) {
      const tripsResult = await apiClient(
        `vehicles/${vehicleId}/trips`,
        HTTP_METHODS.GET,
        {},
        { redirectOnUnauthorized: true },
        {
          'filter[order]': 'startTime DESC'
        }
      );
      const trips = tripsResult.data;
      const tripsWithTagsResult = await apiClient(`vehicles/${vehicleId}/trips-with-tags`, HTTP_METHODS.GET);
      const { vehicleTripsWithTags, vehicleTripsWithPredictedTags } = tripsWithTagsResult.data;

      const result = await Promise.all(
        trips.map(async (trip) => {
          const manualTags = this.groupTagsByType(
            vehicleTripsWithTags.filter((tripWithTags) => tripWithTags.tripid === trip.id)
          );
          const predictedTags = this.groupTagsByType(
            vehicleTripsWithPredictedTags.filter((tripWithTags) => tripWithTags.tripid === trip.id)
          );
          return {
            ...trip,
            manualTags,
            predictedTags
          };
        })
      );
      // do not want reactivity and set array normally
      this.tripsWithManualAndPredictedTags = Object.freeze(result);
    }
  }
};
</script>
